"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var FLSATypeResource = /** @class */ (function (_super) {
    tslib_1.__extends(FLSATypeResource, _super);
    function FLSATypeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FLSATypeResource.endpoint = '/flsatypes';
    FLSATypeResource.MODEL_NAME = 'flsatype';
    return FLSATypeResource;
}(base_1.default));
exports.default = FLSATypeResource;
//# sourceMappingURL=flsatype.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/flsatype.js
// module id = PBXy
// module chunks = 0